export const type = 'web' as const;

export const ENDPOINTS = {
  AUTH: {
    LOGIN: `/${type}/Auth/login`,
    REFRESH_TOKEN: ``,
    AGENCY_DETAILS: `/${type}/AgencyInfo/current`
  },
  LOOKUP: {
    PROFESSION: `/${type}/BaseProfession/lookup`,
    NATIONALITY: `/${type}/BaseNationality/lookup`,
    STATE: `/${type}/BaseState/lookup`,
    SKILLS: `/${type}/BaseSkill/lookup`,
    CITY: `/${type}/BaseCity/lookup`,
    GENDER: `/${type}/BaseGender/lookup`,
    RELIGION: `/${type}/BaseReligion/lookup`,
    MARRIAGE_STATUS: `/${type}/BaseMaritalStatus/lookup`,
    EDUCATION: `/${type}/BaseEducation/lookup`,
    LANGUAGE: `/${type}/Language/lookup`,
    ROLE: `/${type}/Role/lookup`,
    AGEGROUP: `/${type}/BaseAgeGroup/lookup`,
    LANGUAGERATING: `/${type}/Enum/getEnumTranslationItemList/RatingLanguage`,
    GET_IMAGE: `/${type}/Image/get`,

  },
  WORKERS: {
    // WORKERS_DASHBOARD: `/${type}/DraftWorkerInfo/get/search`,
    WORKERS_DASHBOARD: `/${type}/DraftWorkerInfo/WorkerInfoAndDraftWorkerInfo`,
    WORKERS_COUNT: `/${type}/WorkerInfo/Get/workerCountByStatus`,
    WORKERS_COUNT_DRAFT: `/${type}/DraftWorkerInfo/WorkerInfoAndDraftWorkerInfoCount`,
    WORKER_VIEW_EDIT: `/${type}/WorkerInfo/Get-full`,
    DRAFT_VIEW_EDIT: `/${type}/DraftWorkerInfo/Get-full`,
    INDIVIDUAL_UPDATE: `/${type}/DraftWorkerInfo/DraftInsertOrUpdate`,
    DOMESTIC_WORKER_UPDATE: `/${type}/Workerinfo/Update-full`,
    WORKER_DELETE: `/${type}/WorkerInfo/delete`,
    WORKER_DRAFT_DELETE: `/${type}/DraftWorkerInfo/delete`,
    PASSPORTFRONTPARSE: `/Passport/parse`,
    QIDPARSE: `/qid/parse`,
    WORKER_BULK_UPLOAD: `/${type}/WorkerBulkGroup/WorkerBulkUpload`,
    BULK_LIST: `/${type}/WorkerBulkGroup/GetList`,
    BULK_INDIVIDUAL_LIST: `/${type}/WorkerBulkGroup/BulkGroupWorkersList`,


  },
  APPLICATION: {
    APPLICATION_DASHBOARD: `/${type}/CustomerApplication/get/search`,
    MATCHING_LIST: `/${type}/CustomerApplication/getMatchingWorkersList`,
    APPLICATION_DETAILS: `/${type}/CustomerApplication/get`,
    SUBMIT_APP: `/${type}/WorkerApplications/InsertFull`,
    APPLICATION_VIEW_PROFILE: `/${type}/WorkerApplications/get/Workereinfosummary`,
    SHARE_DETAILS: `/${type}/WorkerApplications/get/WorkerApplicationList`,
    SCHEDULE_INTERVIEW: `/${type}/WorkerApplications/ScheduleInterview`,
    REJECT_APPLICATION: `/${type}/WorkerApplications/UpdateStatus`,
  },
  TRACKONBOARDING: {
    TRACK_DASHBOARD: `/${type}/WorkerApplications/get/onboardingList`,
    TRACK_PROGRESS: `/${type}/WorkerApplications/get/OnboardingProgress`,
  },
  DASHBOARD: {
    WORKER_STATUS_COUNT: `/${type}/WorkerInfo/Get/workerCountByStatus`,
    ACCOMMODATION: `/${type}/AgencyAccommodation/get/Report`,
    ASSIGNED_WORKERS: `/${type}/WorkerApplications/get/Report`,
    ASSIGNED_DOMESTIC_WORKERS: `/${type}/WorkerApplications/get/domesticWorkerYearlyReport`,
    GET_WORKER_STATUS_COUNTS: `/${type}/AgencyInfo/worker-status-counts`,
    GET_EMPLOYMENT_PROFESSION_COUNT: `/${type}/AgencyInfo/profession-counts`,
    GET_APPLICATION_STATUS_COUNT: `/${type}/AgencyInfo/application-status-counts`,
    GET_NATIONALITY_COUNTS: `/${type}/AgencyInfo/nationality-counts`,
    GET_PROFESSION_COUNTS: `/${type}/AgencyInfo/profession-counts`,
    GET_APPLICATION_STATUS_COUNTS: `/${type}/AgencyInfo/application-status-counts`,
    GET_AVERAGE_AGENCY_RATING: `/${type}/AgencyRating/get/getAverageAgencyRating`,
    GET_SEARCH_AGENCY_USER: `/${type}/AgencyUser/get/search`,
    COMPLAINT_STATUS_REPORT: `/${type}/Complaints/status-report`
  },
  PROFILE: {
    GET_AGENCY_BANNER: `/${type}/AgencyImage/get`,
    GET_AGENCY_BANNER_LIST: `/${type}/AgencyImage/get/search`,
    INSERT_AGENCY_BANNER: `/${type}/AgencyImage/insert`,
    GET_AGENCY_IFNO: `/${type}/AgencyInfo/get`,
    GET_CONTACT_INFO: `/${type}/AgencyContactInfo/get`,
    GET_CONTACT_INFO_LIST: `/${type}/AgencyContactInfo/get/search`,
    INSERT_AGENCY_CONTACT: `/${type}/AgencyContactInfo/insert`,
    UPDATE_AGENCY_CONTACT: `/${type}/AgencyContactInfo/update`,
    GET_ACCOMMODATION_INFO: `/${type}/AgencyAccommodation/get`,
    LIST_ACCOMMODATION_INFO: `/${type}/AgencyAccommodation/get/search`,
    INSERT_ACCOMMODATION: `/${type}/AgencyAccommodation/insert`,
    INSERT_NATIONALITY: `/${type}/AgencyNationalities/insert`,

    UPDATE_ACCOMMODATION: `/${type}/AgencyAccommodation/update`,
    INSERT_OR_UPDATE_ACCOMMODATION: `/${type}/AgencyAccommodation/InsertOrUpdateAccommodation`,
    GET_NATIONALITIES: `/${type}/AgencyNationalities/get/search`,
    GET_AGENCY_USERS: `/${type}/AgencyUserInfo/get/search`,
    INSERT_AGENCY_USERS: `/${type}/AgencyUser/insert`,
    UPDATE_AGENCY_USERS: `/${type}/AgencyUser/update`,
    INVITE_AGENCY_USER: `/${type}/AgencyUserInvitation/invitation`,
    // todo profile
    GET_AGENCY_PROFILE_LIST: `/${type}/AgencyProfileImage/get/search`,
    INSERT_AGENCY_PROFILE: `/${type}/AgencyProfileImage/insert`,
    UPLOAD_AGENCY_PROFILE_IMAGE: `/${type}/AgencyInfo/uploadImage`,
    ASSIGNED_DOMESTIC_WORKERS: `/${type}/WorkerApplications/get/domesticWorkerYearlyReport`,
    UPDATE_ABOUT_US: `/${type}/AgencyInfo/UpdateAboutus`,
    //review rating
    GET_AGENCY_RATING: `/${type}/AgencyRating/get/getAgencyReviewReport`,
    GET_AGENCY_REVIEW_LIST: `/${type}/AgencyRating/get/search`,
  }

} as const;
